import { createFileRoute } from '@tanstack/react-router'

import CompanyInformation from '../-components/company-information'
import CompanyRatingsGraphs from './-components/company-ratings-graphs/company-ratings-graphs'
import CompanyRatingsTable from './-components/company-ratings-table'

export const Route = createFileRoute(
  '/app/data/companies/$uuid/(mainPage)/debtor/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { uuid } = Route.useParams()

  return (
    <div className="flex h-fit w-full flex-col gap-6 overflow-y-auto">
      <div className="flex h-fit flex-col gap-6 lg:flex-row lg:items-start">
        <CompanyInformation companyUuid={uuid} />
        <CompanyRatingsTable companyUuid={uuid} />
      </div>
      <CompanyRatingsGraphs companyUuid={uuid} />
    </div>
  )
}
